import useTheme from '@mui/material/styles/useTheme';
var isThemeWithId = function (theme) {
    return 'id' in theme;
};
var useThemeId = function () {
    var theme = useTheme();
    var validIds = ['customink'];
    if (!isThemeWithId(theme))
        return undefined;
    return validIds.includes(theme.id) ? theme.id : undefined;
};
export var useThemeProvider = function (id) {
    var themeId = useThemeId();
    return id === themeId;
};
//# sourceMappingURL=useTheme.js.map